






















































































import { Component, Vue, Watch } from "vue-property-decorator";
// @ts-ignore
import * as VueGoogleMaps from "vue2-google-maps";
import ServicosAssistenciaService from "@/service/assistencia24h/ServicosAssistenciaService";
import MessageDialog from "@/components/modal/MessageDialog.vue";
import GsModalDialog from "@/components/modal/GsModalDialog.vue";

@Component({
  components: {
    MessageDialog,
    GsModalDialog
  }
})

export default class Mapa extends Vue {

  dialogType = "";
  showDialog = false;
  dialogTitle = "";
  dialogMessage = "";
  

  markers = {
    "endereco": "87020-720, Maringá, PR, Brasil",
    "latitude": -23.40309,
    "longitude": -51.93351,
    "prestadores": [{
            "nomePrestador": "marcos.tomazini@gmail.com",
            "latitude": -23.40309,
            "longitude": -51.93351,
            "raioDistancia": 1,
            "idPrestador": 1
      }],
      "placa": [{
        "placa": "AAA-1233",
        "velocidade": 0,
        "precisao": 20,
        "latitude": -23.420998,
        "longitude": -51.933055,
        "datahora": "2024-02-14T18:13:58.490+0000"
    }]
  }; // objeto inicial
  
  beforeMount() {
    this.montarPrestadoresPelaRegiao();
  }

  montarPrestadoresPelaRegiao() {

    if (this.$route.query.cep == undefined && this.$route.query.placa != undefined) { // vai por placa
      ServicosAssistenciaService.obterPrestadorPorPlaca(this.$route.query.placa).then((res: any) => {

        console.log(res);

        this.markers.placa = res;
      })
      .catch((err) => {
        console.log(err);
      });
    }

    if (this.$route.query.cep != undefined) {
      let request = {
        "cep": this.$route.query.cep,
        "tipoServico": this.$route.query.tipoServico,
        "tipoVeiculo": this.$route.query.tipoVeiculo,
        "distancia": this.$route.query.distancia,
      };

      ServicosAssistenciaService.obterPrestadoresNaRegiao(request).then((res: any) => {

        console.log(res);

        this.markers = res;
      })
      .catch((err) => {
        console.log(err);
      });
    }
  }

  // /administrativo/mapa?cep=87020-720&tipoServico=GUINCHO&tipoVeiculo=LEVE&distancia=200

  // /administrativo/mapa?placa=AAA-1234

  // https://hml104.genteresolve.com.br/administrativo/#/mapa?cep=87160-000&tipoServico=GUINCHO&tipoVeiculo=LEVE&distancia=200
  mounted() {
    /*this.markers = {
      center: { lat: -23.421000, lng: -51.933056 },
      markers: [
        { id: 1, name: "Oslo", raio: 3, position: {  lat: -23.424384, lng: -51.953026 } },
        { id: 2, name: "Stockholm", raio: 6, position: { lat: -23.421000, lng: -51.933056 } }
      ]
    };*/
  }

  alert(pin:any) {
    this.openDialog('success', '', pin.nomePrestador);
    console.log('Prestador - ' + JSON.stringify(pin));
  }


  private openDialog(dialogType: string, title: string, message: string) {
    this.dialogType = dialogType;
    this.dialogTitle = title;
    this.dialogMessage = message;
    this.showDialog = true;
  }

  public closeDialog(): void {
    this.showDialog = false;
  }

  get btnColor() {
    let color: string;
    switch (this.dialogType) {
      case "success":
        color = "#00CD96";
        break;
      case "error":
        color = "error";
        break;
      case "confirm":
        color = "warning";
        break;
      default:
        color = "primary";
        break;
    }
    return color;
  }

  get btnText() {
    let text: string;
    switch (this.dialogType) {
      case "success":
        text = "OK";
        break;
      case "error":
        text = "Fechar";
        break;
      case "confirm":
        text = "Cancelar";
        break;
      default:
        text = "Ok, entendi";
        break;
    }
    return text;
  }

  get dialogImg() {
    return `${this.dialogType}.png`;
  }

}
